//정적 파일만 참조하는 파일

interface GridRuleContentProps {
	params: any;
	idKey: string;
	backgroundOption: { backgroundColor: string };
	moreOption: { cursor: string, textAlign: string };
	hoveredRowIndex: number | null;
}


const disabledCellSetting = (params: any) => {
	const classes: string[] = [];
	if (params.node.rowPinned === 'bottom') return classes;
	if(params.data?.inserted === true) return classes;
	classes.push('disabled-cell');
	
	return classes;
}

export const bottomCellTotalSetting = (params: any, idKey: string, primaryKey: string) => {
	const classes: string[] = [];
	if (params.node.rowPinned === 'bottom') {
		if(primaryKey === idKey) classes.push('text-align-center');
	}
	return classes;
}

const alignSetting = (params: any) => {
	const classes: string[] = [];

	if (typeof params.value === 'number') {
		classes.push('text-align-right');
	}

	return classes;
}

// export const settingPUR1040_R01CellClasses = (
// 	params: any,
// 	idKey: string,
// 	isSelected: boolean,
// 	isDeleted: boolean,
// ) => {

// 	const classes: string[] = [];

// 	// itemNm, itemSpec 컬럼에 대해 disabledCellSetting 적용
// 	const disabledColumns = ['itemNm', 'itemSpec', 'modelNo'];
// 	if (disabledColumns.includes(idKey)) {
// 		classes.push(...disabledCellSetting(params));
// 	}

// 	const pointerColumns = ['itemCd', 'salesQty', 'salesPrice', 'dcAmt',];
// 	if (pointerColumns.includes(idKey)) {
// 		classes.push('pointer-cursor');
// 	}

// 	classes.push(...alignSetting(params));
// 	classes.push(...bottomCellTotalSetting(params, idKey, 'itemCd'));

// 	return classes;
// }

export const settingSAL6010_R01CellClasses = (
	params: any,
	idKey: string,
	isSelected: boolean,
	isDeleted: boolean,
) => {

	const classes: string[] = [];

	// itemNm, itemSpec 컬럼에 대해 disabledCellSetting 적용
	const disabledColumns = ['itemNm', 'itemSpec', 'modelNo'];
	if (disabledColumns.includes(idKey)) {
		classes.push(...disabledCellSetting(params));
	}

	const pointerColumns = ['itemCd', 'salesQty', 'salesPrice', 'dcAmt',];
	if (pointerColumns.includes(idKey)) {
		classes.push('pointer-cursor');
	}

	classes.push(...alignSetting(params));
	classes.push(...bottomCellTotalSetting(params, idKey, 'itemCd'));

	return classes;
}

export const settingSAL6020_R01CellClasses = (
	params: any,
	idKey: string,
	isSelected: boolean,
	isDeleted: boolean,
) => {

	const classes: string[] = [];

	// itemNm, itemSpec 컬럼에 대해 disabledCellSetting 적용
	const disabledColumns = ['itemNm', 'itemSpec', 'modelNo'];
	if (disabledColumns.includes(idKey)) {
		classes.push(...disabledCellSetting(params));
	}

	const pointerColumns = ['itemCd', 'salesQty', 'salesPrice', 'dcAmt',];
	if (pointerColumns.includes(idKey)) {
		classes.push('pointer-cursor');
	}

	classes.push(...alignSetting(params));
	classes.push(...bottomCellTotalSetting(params, idKey, 'itemCd'));

	return classes;
}